import React, { FC } from 'react';
import styled from 'styled-components';

const _ServerIconAccountMenu: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} width='20' height='20' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M1.875 4.6731V17.1731H18.125V4.6731H1.875ZM3.125 5.9231H16.875V8.4231H3.125V5.9231ZM4.375 6.5481V7.7981H9.375V6.5481H4.375ZM15 6.5481C14.6558 6.5481 14.375 6.82886 14.375 7.1731C14.375 7.51733 14.6558 7.7981 15 7.7981C15.3442 7.7981 15.625 7.51733 15.625 7.1731C15.625 6.82886 15.3442 6.5481 15 6.5481ZM3.125 9.6731H16.875V12.1731H3.125V9.6731ZM4.375 10.2981V11.5481H9.375V10.2981H4.375ZM15 10.2981C14.6558 10.2981 14.375 10.5789 14.375 10.9231C14.375 11.2673 14.6558 11.5481 15 11.5481C15.3442 11.5481 15.625 11.2673 15.625 10.9231C15.625 10.5789 15.3442 10.2981 15 10.2981ZM3.125 13.4231H16.875V15.9231H3.125V13.4231ZM4.375 14.0481V15.2981H9.375V14.0481H4.375ZM15 14.0481C14.6558 14.0481 14.375 14.3289 14.375 14.6731C14.375 15.0173 14.6558 15.2981 15 15.2981C15.3442 15.2981 15.625 15.0173 15.625 14.6731C15.625 14.3289 15.3442 14.0481 15 14.0481Z'
            fill='#000000'
        />
    </svg>
);

const ServerIconAccountMenu = styled(_ServerIconAccountMenu)``;

export default ServerIconAccountMenu;
